import React from "react";
import "./Quests.css";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import BackButton from "../Goback/GoBack";
import useStudentProgressInfo from "../../../../hooks/school/parent/useStudentProgressInfo";

export const SchoolParentQuestInfo = () => {
  const { studentId, questId, kidName } = useParams(); // Get studentId from URL

  const { kidDetail, loading } = useStudentProgressInfo(studentId, questId);

  return (
    <div className="dashboardBody">
      <div className="container-fluid p-0">
        <div className="p-0" id="mainContent">
          <div className="teacher-bodycontent mb-4">
            <section>
              <div className="container-fluid">
                <div className="row mb-4">
                  <div className="col-md-12">
                    <BackButton />
                  </div>
                  {loading ? (
                    <div className="col-md-12 mt-4">
                      <div className="bg-white px-5 py-4">
                        <div className="row align-items-center">
                          {/* Avatar skeleton */}
                          <div className="col-md-1 text-center">
                            <span
                              className="placeholder rounded-circle bg-secondary"
                              style={{ width: 48, height: 48 }}
                            ></span>
                          </div>

                          {/* Name skeleton */}
                          <div className="col-md-11">
                            <span className="placeholder placeholder-glow col-4 rounded"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-12 mt-4">
                      <div className="bg-white px-5 py-4">
                        <div className="row align-items-center">
                          <div className="col-md-1">
                            <p className="mb-0 schlParentNameAV">
                              {kidDetail?.student?.name
                                ?.split(" ")
                                .map((word) => word.charAt(0))
                                .join("")
                                .toUpperCase()}
                            </p>
                          </div>

                          <div className="col-md-11">
                            <p className="mb-2 schlParentName">
                              {kidDetail?.student?.name}
                            </p>
                            <p className="mb-2 schlParentName">
                              Student ID: {kidDetail?.student?.username}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {loading ? (
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="row">
                        {[1, 2, 3].map((_, idx) => (
                          <div className="col-md-4 col-sm-6 mb-4" key={idx}>
                            <div className="stat-card bg-secondary bg-opacity-25">
                              <div className="p-3">
                                {/* Title */}
                                <span className="placeholder placeholder-glow col-7 mb-2 rounded bg-secondary bg-opacity-25"></span>

                                {/* Value */}
                                <span className="placeholder placeholder-glow col-4 rounded bg-secondary bg-opacity-25"></span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="row">
                        <div className="col-md-4 col-sm-6 mb-4">
                          <div className="stat-card blueGradientCard">
                            <div className="row">
                              <div className="col-md-12 col-sm-12 col-12">
                                <p className="TchrQuestCardTitl mb-2">
                                  Overall Progress %
                                </p>
                                <p className="yuvadashboard-cardtxt mb-0">
                                  {kidDetail?.student?.overall_progress}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-6 mb-4">
                          <div className="stat-card OrangeGradientCard">
                            <div className="row">
                              <div className="col-md-12 col-sm-12 col-12">
                                <p className="TchrQuestCardTitl mb-2">
                                  Average Quiz Score
                                </p>
                                <p className="yuvadashboard-cardtxt mb-0">
                                  {kidDetail?.student?.avg_quiz_score}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-6 mb-4">
                          <div className="stat-card GreenGradientCard">
                            <div className="row">
                              <div className="col-md-12 col-sm-12 col-12">
                                <p className="TchrQuestCardTitl mb-2">
                                  Total Quests Assigned
                                </p>
                                <p className="yuvadashboard-cardtxt mb-0">
                                  {kidDetail?.student?.total_quests_assigned}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </section>

            <section>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    {/* QUEST TITLE */}
                    <div id="task_count_title" className="mb-3 text-uppercase">
                      QUEST: {kidDetail?.quest?.title}
                    </div>

                    <div className="table-responsive">
                      <table className="table table-hover tchrtabl-pdng">
                        <thead className="quest-tablehead">
                          <tr>
                            <th scope="col">Episode</th>
                            <th scope="col" className="text-center">
                              Best Score
                            </th>
                            <th scope="col" className="text-center">
                              Attempts
                            </th>
                          </tr>
                        </thead>

                        <tbody className="tchrtablbody">
                          {kidDetail?.episodes?.length > 0 ? (
                            kidDetail.episodes.map((ep, index) => (
                              <tr key={index}>
                                <td>{ep.episode}</td>

                                <td className="text-center">{ep.best_score}</td>

                                <td className="text-center">{ep.attempts}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No episodes found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
